import instObj from '@/backend/axios-instances'

const resource = "/cutsheets/parts"
const instance = instObj.baseInstance

export default {
  post(data, parameters) {
    return instance.post(resource, data, { params: parameters });
  },
  get(parameters) {
    return instance.get(resource, { params: parameters });
  }
}
